export default class SearchForm{

    constructor() {
        this.search_button = document.querySelector('#toggle-search');
        this.search_form = document.querySelector('.search-form');

        if( this.search_button && this.search_form ){

            // event listener that toggles the search field 
            this.search_button.addEventListener( 'click', this.handle_search_button_click.bind(this));

        }
    }

    /**
     * 
     * @param {*} e 
     * @returns 
     */
    handle_search_button_click(e){
        return this.search_form.classList.contains( 'active' ) ? this.close_search() : this.open_search()
    }

    /**
     * 
     */
    open_search(){

        this.keydown_handler = this.close_search_on_escape.bind(this);
        window.addEventListener("keydown", this.keydown_handler );
        
        // this.scroll_handler = this.close_search_on_scoll.bind(this);
        // window.addEventListener("scroll", this.scroll_handler );

        jQuery('.search-form').addClass('active').fadeIn();

    }
    
    /**
     * 
     */
    close_search(){
        
        // window.removeEventListener("scroll", this.scroll_handler );
        window.removeEventListener("keydown", this.keydown_handler );

        jQuery('.search-form').removeClass('active').fadeOut();

    }
    
    /**
     * 
     * @returns 
     */
    close_search_on_scoll(){
        return this.close_search();
    }
    
    /**
     * 
     * @param {*} e 
     * @returns 
     */
    close_search_on_escape(e){
        if( "Escape" == e.key ){
            return this.close_search();
        }
    }
}